import Head from 'next/head';
import { useEffect } from 'react';

import { CheckBalance } from 'gift-cards/components/checkBalance/CheckBalance';
import { setIsFooterVisible } from 'store/slice/pageLayoutSlice';
import { usePageMetadata } from 'shared/hooks/usePageMetadata';
import { useStoreDispatch } from 'store/hooks/storeHooks';
import { t } from 'localization/utils/t';

const TP = 'pages.giftCards.balance';

const GiftCardCheckBalancePage = () => {
  const storeDispatch = useStoreDispatch();
  const { pageTitle } = usePageMetadata({
    defaultTitle: t(`${TP}.title`, 'Check Gift Card Balance '),
  });

  useEffect(() => {
    storeDispatch(setIsFooterVisible(false));
  }, []);

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta property="og:title" content={pageTitle} key="og:title" />
        <meta
          name="description"
          content={t(
            `${TP}.description`,
            'Easily check your GOAT Gift Card balance online at GOAT.com. Simply enter the number and email address associated with your GOAT Gift Card to check your balance.',
          )}
          key="description"
        />
      </Head>
      <CheckBalance />
    </>
  );
};

export default GiftCardCheckBalancePage;
